import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateManagerProfileMutation, useGetManagerProfileMutation } from '../../../api/ManagerAPI';
import { IManagerProfile, IManagerProfileRequest, IProfileDto } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../manager.module.scss';
import Footer from '../../footer/Footer';

const emptyDto: IManagerProfileRequest = {
  uid: '',
  email: '',
  name: '',
  passwort: '',
}

export default function ManagerProfileDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [getManagerProfileAPI] = useGetManagerProfileMutation();
  const [createOrUpdateProfileService] = useCreateOrUpdateManagerProfileMutation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IManagerProfileRequest>(emptyDto);

  const init = () => {
    //
    if (location.state.view === 'detail') {
      getManagerProfileAPI(location.state.id)
        .unwrap()
        .then((e) => setDaten({
          uid: e.uid,
          email: e.email,
          name: e.name,
          passwort: '',
        }))
        .catch((ee) => console.log(ee))
        .finally(() => setLoaded(true));

    } else if (location.state.view === 'create') {
      setDaten(emptyDto)
      setLoaded(true);
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail') {

      createOrUpdateProfileService(daten)
        .then(() => navigate('/manager/profiles/'))
        .catch((ee) => console.log(ee))
    }

    if (location.state.view === 'create') {

      createOrUpdateProfileService(daten)
        .then(() => navigate('/manager/profiles/'))
        .catch((ee) => console.log(ee))
    }

  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  /*const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }*/

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Profile Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          {(isLoaded && daten !== undefined &&
            <>
              <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >

                {/*<div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.email}</span></div>
                  <div style={{ textAlign: "end" }}></div>
                </div>*/}

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>E-Mail-Adresse*</label><input type="email" spellCheck={false} autoComplete='new-password' required={true} className={styles['wg-input-text']} name="email" value={daten?.email} onChange={changeit} /></div>
                  <div></div>
                  <div><label className={styles['wg']}>Name</label><input type="text" className={styles['wg-input-text']} name="name" value={daten?.name} onChange={changeit} /></div>
                  <div></div>
                  <div><label className={styles['wg']}>Passwort{(location.state.view === 'create') ? "*" : ""}</label><input required={(location.state.view === 'create') ? true : false} type="password" autoComplete='new-password' className={styles['wg-input-text']} name="passwort" value={daten?.passwort} onChange={changeit} /></div>
                  <div></div>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                </div>

              </form>
            </>)}

        </div>
      </div>

      <Footer />
    </>
  );
}